__webpack_require__.p = "https://gis.cdc.gov/fa_injury/";